<template>
  <div class="b2b-solutions">
    <div class="container">
      <h1>{{ label_top_title }}</h1>

      <div class="group">
        <div class="solution clearfix" :class="chunk.chunkAlignment">
          <div class="item"
            v-for="current_solution in solutions"
            v-bind:key="current_solution.solutionId"
            v-on:click="selectSolution(current_solution)"
            :class="{[chunk.chunkClass] : true, 'active': solution == current_solution }"
          >
            <div class="wrapper">
              <img :src="current_solution.image" />
              <span style="display:block;">{{ current_solution.title }}</span>
            </div>
          </div>
        </div>
        <div class="type">
          <span v-for="item in items" v-bind:key="item.itemId">
            <label><input type="checkbox"
              :value="item.itemId"
              v-model="item.selected"> {{ item.title }}</label>&nbsp;
          </span>
        </div>
        <div class="selection" v-if="items.length > 0">
          <div class="row">
            <div class="col-12">
              <div class="vehicles" v-if="!isRoof()">
                  <dealer-canopy
                    v-on:selectCanopy="selectCanopy($event)"
                    :label_manufacturer="label_manufacturer"
                    :label_canopy="label_canopy"
                    :label_select="label_select"
                    :label_vehicle_type="label_vehicle_type"
                  ></dealer-canopy>
                </div>
                <div class="vehicles" v-if="isRoof()">
                  <dealer-roof
                    v-on:selectVehicle="selectVehicle($event)"
                    :label_manufacturer="label_manufacturer"
                    :label_model="label_model"
                    :label_year="label_year"
                    :label_body_type="label_body_type"
                    :label_loading="label_loading"
                    :label_select="label_select"
                    :vehicle_type="solution.vehicle_type"
                  ></dealer-roof>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dealer-solutions",
  props: {
    label_manufacturer: {
      type: String,
      default: "Manufacturer"
    },
    label_model: {
      type: String,
      default: "Model"
    },
    label_year: {
      type: String,
      default: "Year"
    },
    label_body_type: {
      type: String,
      default: "Body Type"
    },
    label_vehicle_type: {
      type: String,
      default: "Vehicle Type"
    },
    label_loading: {
      type: String,
      default: "Loading"
    },
    label_select: {
      type: String,
      default: "Select"
    },
    label_canopy: {
      type: String,
      default: "Canopy"
    },
    label_roof: {
      type: String,
      default: "Roof"
    },
    label_top_title: {
      type: String,
      default: "Roof"
    },
    chunk: {
      type: Object,
    }
  },
  data() {
    return {
      solutions: [],
      solution: null,
      items: []
    }
  },
  mounted() {
    this.loadSolutions();
  },
  methods: {
    async loadSolutions() {
      let solutionsResponse = await axios.get(`api/solutions`);
      this.solutions = solutionsResponse.data.data;
      if (this.solutions && this.solutions.length > 0) {
        this.selectSolution(this.solutions[0]);
      }
    },
    async selectSolution(solution) {
      this.solution = solution;
      let solutionResponse = await axios.get(`api/solutions/${this.solution.solutionId}`);
      this.items = solutionResponse.data.data.map(item => {
        item.selected = true;
        return item;
      });
    },
    isRoof() {
      return !this.solution || this.solution.solution_type != 'canopy';
    },
    selectCanopy(canopy) {
      var cat = [];
      for(var i = 0; i < this.items.length; i++) {
        if (this.items[i].selected && this.items[i].categories) {
          for (var ii = 0; ii < this.items[i].categories.length; ii++) {
            cat.push(this.items[i].categories[ii].categoryId);
          }
        }
      }
      window.location = 'fit-my-car/results/canopy/' + canopy.canopyId + '?categories=' + cat.join(',');
    },
    selectVehicle(roof) {
      var cat = [];
      for(var i = 0; i < this.items.length; i++) {
        if (this.items[i].selected && this.items[i].categories) {
          for (var ii = 0; ii < this.items[i].categories.length; ii++) {
            cat.push(this.items[i].categories[ii].categoryId);
          }
        }
      }
      //window.location = 'fit-my-car/results/' + roof.internalUniqueId + '/' + roof.title + '?categories=' + cat.join(','); changes - RRI-646
      window.location = 'fit-my-car/results/' + roof.internalUniqueId + '/true?categories=' + cat.join(',');
    }
  }
};
</script>
